import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { GameActions } from "../state/GameReducer.js";

/**
 * @name StartMatch
 * @class StartMatch
 * @extends {ConnectedHTMLElement}
 * @description
 * This class is a custom HTML element that will be used to start a match. It is empty if match is started.
 */
export class StartMatch extends ConnectedHTMLElement {
  static observedAttributes = ["player"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    const div = this.querySelector(`#${player}-start-match`);
    // Bases are selected, but the game has not started yet
    if (
      newState.top.base !== undefined &&
      newState.bottom.base !== undefined &&
      newState.currentGame === undefined
    ) {
      div.classList.remove("hidden");
      const btn = this.querySelector(`#${player}-start-match-btn`);
      if (btn) {
        btn.disabled = false;
      }
      return;
    }
    // A game has been started
    if (
      newState.currentGame !== undefined &&
      oldState.currentGame === undefined
    ) {
      div.classList.add("hidden");
    }
  }

  handleButtonClick(e) {
    e.preventDefault();
    DispatchAction(GameActions.start);
  }

  registerEvents() {
    const player = this.getAttribute("player");
    const button = this.querySelector(`#${player}-start-match-btn`);
    if (button) {
      button.addEventListener("click", this.handleButtonClick);
    }
  }

  render() {
    const player = this.getAttribute("player");
    this.innerHTML = `
        <div
        class="z-[5] h-[80px] max-w-[500px] bottom-[25%] p-2 flex flex-row justify-center items-center absolute w-full hidden"
        id="${player}-start-match"
      >
        <button
          type="button"
          class="btn btn-success btn-xl flex flex-col w-full btn-primary font-bold text-xl text-neutral"
          id="${player}-start-match-btn"
        >
          <span>Start match!</span>
        </button>
      </div>`;
  }

  connectedCallback() {
    this.render();
    this.registerEvents();
  }
  disconnectedCallback() {
    const player = this.getAttribute("player");
    const button = this.querySelector(`#${player}-start-match-btn`);
    if (button) {
      button.removeEventListener("click", this.handleButtonClick);
    }
  }
}
